import { Briefcase, Mail, Phone } from 'lucide-react'
import { type ReactElement } from 'react'

import { Item } from '@orus.eu/pharaoh-next/components/ui/item'
import { Logo } from '@orus.eu/pharaoh-next/components/ui/logo'
import { mailtoHref, telHref } from '@orus.eu/pharaoh-next/lib/contact-href'

import { ContactLinkItem } from './contact-link-item.tsx'

import { useFormatPhoneNumber } from '#/lib/hooks/use-format-phone-number.ts'

type BrokerContactSectionsProps = {
  brokerDisplayName: string
  brokerPhone: string | undefined
  brokerEmail: string | undefined
  orusEmail: string | undefined
}

export function BrokerContactSections({
  brokerDisplayName,
  brokerPhone,
  brokerEmail,
  orusEmail,
}: BrokerContactSectionsProps): ReactElement {
  const formatPhoneNumber = useFormatPhoneNumber()

  return (
    <>
      {(brokerPhone ?? brokerEmail) ? (
        <div className="flex flex-col gap-40">
          <Item.Root variant="plain">
            <Item.Media className="size-[40px] rounded-full bg-surface-base-secondary">
              <Briefcase aria-hidden className="size-[16px]" />
            </Item.Media>
            <Item.Content>
              <Item.Title>{brokerDisplayName}</Item.Title>
            </Item.Content>
          </Item.Root>

          <Item.Group>
            {brokerPhone ? (
              <ContactLinkItem
                icon={<Phone aria-hidden className="size-[16px]" />}
                label={formatPhoneNumber(brokerPhone)}
                href={telHref(brokerPhone)}
              />
            ) : null}

            {brokerEmail ? (
              <ContactLinkItem
                icon={<Mail aria-hidden className="size-[16px]" />}
                label={brokerEmail}
                href={mailtoHref(brokerEmail)}
              />
            ) : null}
          </Item.Group>
        </div>
      ) : null}

      <div className="flex flex-col gap-40">
        <Item.Root variant="plain">
          <Item.Media className="size-[40px]">
            <Logo variant="favicon" aria-hidden className="size-full" />
          </Item.Media>
          <Item.Content>
            <Item.Title>ORUS</Item.Title>
          </Item.Content>
        </Item.Root>

        {orusEmail ? (
          <Item.Group variant="divided">
            <ContactLinkItem
              icon={<Mail aria-hidden className="size-[16px]" />}
              label={orusEmail}
              href={mailtoHref(orusEmail)}
            />
          </Item.Group>
        ) : null}
      </div>
    </>
  )
}
